import { LogoutIcon } from '@heroicons/react/outline';
import { TriangleAlertIcon } from 'lucide-react';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { ROUTES } from '@config/routes-config';
import { authorize, experienceRules } from '@services/api/login-service';
import { useGlobalStore } from '@services/store/global-store';
import { useAuth } from '../../../context/AuthContext';
import { useConfig } from '@components/ConfigProvider';
import useDataAnalytics from '@services/api/data-analytics.service';

const LoginPageCCNCSSO: React.FC = () => {
  const { updateUserDetails, updatePreferences, updateIsNC } = useGlobalStore(
    (state) => state
  );
  const config = useConfig();
  const navigate = useNavigate();
  const { pageChanged } = useDataAnalytics(
    useGlobalStore.getState().userDetails
  );
  const [error, setError] = useState<React.ReactNode | null>(null);
  const [userState, setUserState] = useState('');
  const { login, logout } = useAuth();
  const state =
    useGlobalStore((state) => state.userDetails.userInformation.state) || '';

  useEffect(() => {
    if (window.location.hostname.includes('nccarepointsconnect')) {
      updateIsNC(true);
    }
    authorizeOIDCFlow();
  }, []);

  async function getExperienceRules(): Promise<any> {
    try {
      const request = {
        cce: useGlobalStore.getState().userDetails.userInformation.cceName,
        state: useGlobalStore.getState().userDetails.userInformation.state,
        parse: true
      };
      const response = await experienceRules(request);
      if (response.status === 'SUCCESS') {
        updatePreferences(response);
        navigate(ROUTES.DASHBOARD);
      } else {
        setError(
          'Access Temporarily Unavailable: Please contact your administrator for assistance.'
        );
      }
    } catch (error) {
      console.log(error);
      setError('System Error Occurred, Please contact IT support.');
    }
  }

  const authorizeOIDCFlow = async () => {
    try {
      // Use OIDC authentication instead of legacy authorize

      const requestPayload = {
        authType: 'SSO',
        ssoType: 'CCNCSSO',
        cce: 'CCNC'
      };

      const response = await authorize(requestPayload);

      //  const response = await authorizeOIDC();
      console.log('OIDC Response:', response);

      if (response && response.status === 'SUCCESS') {
        const { status, userId, userInformation, jwtToken } = response;

        // Log the user ID for debugging
        console.log('Logged in User ID:', userId);
        console.log('User Information:', userInformation);

        updateUserDetails({
          status,
          userId,
          userInformation,
          jwtToken
        });

        pageChanged();
        login();
        getExperienceRules();
      } else {
        setError(
          'Access Temporarily Unavailable: Please contact your administrator for assistance.'
        );
      }
    } catch (error) {
      console.log('OIDC Authorization Error:', error);
      setError(
        'System Error Occurred, Please contact your administrator for assistance.'
      );
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="border card p-8 bg-white rounded-lg shadow-md">
        <>
          {!error && (
            <div className="text-center">
              <p className="text-gray-600 mb-4">
                Please wait while we process your request.
              </p>
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500 mx-auto"></div>
            </div>
          )}
        </>
        <div>
          {error && (
            <p className="text-red-500 text-center">
              <div className="w-full flex justify-center ">
                <TriangleAlertIcon className="size-1/5 text-red-500" />
              </div>
              {error}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default LoginPageCCNCSSO;
